module.exports = __webpack_public_path__ + "static/media/taimalishan6.95797198.webp";